import React, { useState, useEffect } from 'react';
import Styles from './styles.module.css';
import { getFirestore, query, collection, where, getDocs } from 'firebase/firestore';
import Title from '../title';

type RecruitPagesPostsProps = {
  companyId: string;
};

const RecruitPagesPosts: React.FC<RecruitPagesPostsProps> = ({ companyId }) => {

  const [ photos, setPhotos ] = useState<string[]>([]);

  const [ time, setTime ] = useState<number>(0);

  useEffect(() => {
    var timeInit = new Date().getTime();
    setTime(timeInit);

    const fetchPosts = async () => {
      const db = getFirestore();

      const postsQuery = query(
        collection(db, "posts"),
        where("companyId", "==", companyId)
      );

      const querySnapshot = await getDocs(postsQuery);
      const tmp: any[] = [];
      querySnapshot.forEach((doc) => {
        // post_status未設定の既存投稿は「公開中」として扱う(後方互換)
        const status = doc.data().post_status ?? '公開中';
        if (status !== '非公開' && status !== 'アーカイブ') {
          tmp.push(doc.id);
        }
      });

      setPhotos(tmp);
    };

    if (companyId) {
      fetchPosts();
    }
  }, [companyId]);

  return (
    <>
    {0 !== photos.length ?
    <>
      <div className={Styles.hr}></div>
      <Title 
        title={"スタイル"}
        desc={"店舗で作ったスタイルを紹介"} />
    </> : <></> }
      
    <div className={Styles.photos}>
      <div>
        {photos.map((data, index) =>
          <img alt='' key={index} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/image%2Fresize_images%2F${data}_500x500?alt=media&token=${time}`} />
        )}
      </div>
    </div>
    </>
  );
}

export default RecruitPagesPosts;
